// Action types
const SET_TABS = "spirit/utils/SET_TABS";

// InitialState
export const initialState = {
  tabs: [],
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TABS:
      return {
        ...state,
        tabs: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const setTabs = (info) => ({
  type: SET_TABS,
  info,
});
